/**
 * JavaScript Optimization - PhysioPulse™
 * Optimisations pour améliorer les performances et corriger les erreurs
 */

// Supprimer les console.log en production
(function() {
  'use strict';
  
  // Désactiver console.log en production (optionnel)
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    // console.log = function() {};
  }
  
  // Optimisation: Debounce pour les événements de scroll
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  // Optimisation: Lazy load des images
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            observer.unobserve(img);
          }
        }
      });
    });
    
    document.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  }
  
  // Optimisation: Préchargement des ressources critiques
  function preloadCriticalResources() {
    const criticalImages = [
      // Ajoutez ici les URLs des images critiques
    ];
    
    criticalImages.forEach(url => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = url;
      document.head.appendChild(link);
    });
  }
  
  // Exécuter après le chargement du DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preloadCriticalResources);
  } else {
    preloadCriticalResources();
  }
  
  // Gestion d'erreurs globale
  window.addEventListener('error', function(e) {
    // Logger les erreurs sans bloquer l'exécution
    if (window.console && console.error) {
      console.error('Erreur JavaScript:', e.error);
    }
    return true; // Empêcher la propagation
  });
  
  // Optimisation: Réduire les reflows
  let rafId = null;
  function optimizeReflow() {
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(() => {
      // Code qui nécessite un reflow
    });
  }
  
  // Exporter les fonctions utiles
  window.PhysioPulseOptimizations = {
    debounce: debounce,
    optimizeReflow: optimizeReflow
  };
})();

